import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { ItemResultLayoutComponentsProviderComponentBase, RenderInItemResultLayoutDirective } from 'products-ui';
import { PunchoutItemPricingComponentStore } from 'punchout-data';
import { PunchoutPromoRibbonComponent } from '../promo-ribbon/punchout-promo-ribbon.component';
import { ProductTypes } from 'products-data';
import { MatIconModule } from '@angular/material/icon';
import { LeadTimeNotificationChipComponent } from '../lead-time-notification-chip/lead-time-notification-chip.component';

@Component({
  selector: 'ideal-punchout-item-result-layout-components-provider',
  standalone: true,
  providers: [PunchoutItemPricingComponentStore],
  imports: [RenderInItemResultLayoutDirective, PunchoutPromoRibbonComponent, MatIconModule, LeadTimeNotificationChipComponent],
  templateUrl: './punchout-item-result-layout-components-provider.component.html',
  styleUrls: ['./punchout-item-result-layout-components-provider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PunchoutItemResultLayoutComponentsProviderComponent extends ItemResultLayoutComponentsProviderComponentBase {
  protected readonly store = inject(PunchoutItemPricingComponentStore);
  protected readonly ProductTypes = ProductTypes;
  protected readonly stockLocation = computed(() => this.store.itemStock()?.stockLocation);
  protected readonly hasStock = computed(() => this.store.itemStock()?.stock?.some((s) => s.quantity > 0));
  constructor() {
    super();
    effect(() => this.store.selectItemById(this.id()));
    effect(() => this.store.selectItemStockById(this.id()));
  }
}
